<template>
  <div>
    <v-flex pa-3 xs12 sm12 md12 v-if="val.SatisGrupHizmetTip != 0">
      <v-hover>
        <v-card
          width="100%"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2}`"
          class="elevation-1 pa-3"
        >
          <v-layout row wrap align-center justify-end>
            <v-flex xs12 sm6 md1>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-medium grey--text subheader"
                >
                  <v-icon color="#67768f" small>fiber_manual_record</v-icon>
                  {{ getSaticiTip(val.SatisGrupHizmetTip, SaticiTip) }}
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md1>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-regular headline"
                style="color: #67768f"
              >
                {{ val.PNR_No }}
              </v-flex>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-bold grey--text caption"
                >
                  <v-icon color="#67768f" small>payment</v-icon>
                  {{ val.SaticiAd }} / {{ val.SaticiKod }}
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md2>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-large grey--text caption"
                ><span style="color: #67768f"> {{ $t('Sales-Amount-v3') }}  :</span>
                {{ moneyformat(val.SatisTutari) }} {{ val.ParaBirimi }}
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                class="font-weight-large grey--text caption"
                ><span style="color: #67768f">Kur:</span>
                {{ moneyformat(val.SatisKur) }} 
              </v-flex>
            </v-flex>

            <v-layout row align-center justify-space-around>
              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                  ><span style="color: #67768f">{{ $t('Amount') }} {{ paraBirimi }} : </span>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                >
                  {{ moneyformat(val.Tutar) }} 
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                  ><span style="color: #67768f">{{ $t('Paid') }} {{ paraBirimi }} :</span>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                >
                  {{ moneyformat(val.Odenen) }} 
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                  ><span style="color: #67768f">{{ $t('Remaining') }} {{ paraBirimi }} :</span>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text body-1"
                >
                  {{ moneyformat(val.Kalan) }} 
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-flex xs12 sm12 md12>
                  <parainput
                    :etiket="$t('Payment-Amount')"
                    :autocomplete="'autocomplete'"
                    v-model="odenecekTutar"
                    :simge="paraBirimi"
                  >
                  </parainput>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md1>
                <v-flex xs12 sm12 md12>
                  <v-btn
                    icon
                    small
                    slot="activator"
                    flat
                    @click="pnrTahsilatDialog(val.PNR_No)"
                  >
                    <v-icon color="info" medium git>search</v-icon>
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
      </v-hover>
    </v-flex>

    <v-dialog
      v-model="dialogOdemeStatus"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialogOdemeStatus = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title> {{ $t('Add-v2', { value: $t('Payment')}) }}   </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="odemeEkle()"> {{ $t('Add-v2', { value: $t('Payment')}) }} </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex v-if="dialogOdemeStatus" xs12 sm12 md12>
              <pnrodeme
                ref="pnrOdeme"
                :pnrNo="compPnrNo"
                v-model="Odeme"
              ></pnrodeme>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import parainput from "@/components/app/customcomp/parainput.vue";
import pnrodeme from "../../component/pnrodeme.vue";

export default {
  props: ["value", "paraBirimi", "kurDegeri", "getData","getDataTaksim"],
  components: {
    parainput,
    pnrodeme,
  },
  computed: {
    val: {
      get: function () {
        this.odenecekTutar = 0.0;
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      compPnrNo: 0,
      dialogOdemeStatus: false,
      Odeme: {
        OdemeTarihi: null,
        OdemeTipi: 0,
        NakitBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        KrediKartBilgi: {
          KarsiCari: {
            kod: null,
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
          FirmaKrediKartli: false,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: 0,
          PosKodu: null,
          PosTaksit: null,
          PuanTutari: 0,
        },
        HavaleBilgi: {
          Banka: null,
          Aciklama: null,
        },
        SanalPosBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        Tutar: 0,
        ParaBirimi: "TL",
        Kur: 1,
        OdemeIadesi: false,
        PNR_No: null,
        EvrakNo: null,
        Aciklama: null,
      },
      odenecekTutar: 0.0,
      SaticiTip: [
        {
          Aciklama: "Konsolosluk",
          Kod: 1,
        },
        {
          Aciklama: "Sigorta",
          Kod: 2,
        },
        {
          Aciklama: "Hizmet",
          Kod: 3,
        },
        {
          Aciklama: this.$t('Other'),
          Kod: 4,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 1",
          Kod: 5,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 2",
          Kod: 6,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 3",
          Kod: 7,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 4",
          Kod: 8,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 5",
          Kod: 9,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 6",
          Kod: 10,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 7",
          Kod: 11,
        },
      ],
    };
  },
  methods: {
    pnrTahsilatDialog(pnrNo) {
      this.dialogOdemeStatus = true;
      this.compPnrNo = pnrNo;
    },
    odemeEkle() {
      this.$refs.pnrOdeme.addOdeme();
    },
    getSaticiTip: function (satisTip, satisList) {
      let _resultSaticTipText = null;
      satisList.forEach((element) => {
        if (element.Kod == satisTip) {
          _resultSaticTipText = element.Aciklama;
        }
      });
      return _resultSaticTipText;
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
  },
  beforeMount: beforeMount,
  watch: {
    dialogOdemeStatus: function () {
      if (!this.dialogOdemeStatus) {
        this.$emit("getodenecekler");
      }
    },
    getDataTaksim:function (){
      if(this.getDataTaksim != 0){
        let priceInfo = {
          PNR_No: this.val.PNR_No,
          Tutar: this.odenecekTutar,
        };
        this.$emit("odemeHazirlaTaksim", priceInfo);
      }
    },
    getData: function () {
      if (this.getData != 0) {
        let priceInfo = {
          PNR_No: this.val.PNR_No,
          Tutar: this.odenecekTutar,
        };
        this.$emit("odemeHazirla", priceInfo);
      }
    },
    odenecekTutar: function (newVal, oldVal) {
      var _totalResult = newVal - oldVal;
      this.$emit("odenecekTutarHesapla", _totalResult);
    },
    kurDegeri: function (newVal, oldVal) {
      this.$emit("odenecekTutarSifirla");
      this.odenecekTutar = 0;
    },
  },
};

function beforeMount() {

}
</script>

<style>
</style>